import React from 'react';
import { Contact } from '../components/Contact';
import { CompanyBanner } from '../components/CompanyBanner';

export default function ContactPage() {
  return (
    <>
      <CompanyBanner />
      <Contact />
    </>
  );
}
